import GQLoader from 'components/GQLoader/GQLoader';
import { isEmpty } from 'lodash/fp';
import { TBody, TR, TD } from '../InsightTemplate/InsightTemplateElements';
import { useParams } from 'react-router-dom';
import PredictionTemplatePdfHeader from './PredictionTemplatePdfHeader';
import PredictionTemplatePdfBody from './PredictionTemplatePdfBody';
import usePredictionTemplate from './usePredictionTemplate';

const PredictionTemplatePdf = () => {
    const {id} = useParams();
    const { prediction, countryName } = usePredictionTemplate(id);

    if (isEmpty(prediction)) {
        return <GQLoader />;
    }

    return (
        <table
            style={{
                width: '100%',
                fontFamily:
                    '"Open Sans", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
            }}>
            <TBody>
                <TR>
                    <TD align="center">
                        <table
                            className="gq-template-prediction-pdf"
                            style={{
                                width: '600px',
                                backgroundColor: 'white',
                                color: 'black',
                            }}>
                            <TBody>
                                <PredictionTemplatePdfHeader
                                    title={prediction.abbreviation}
                                    country={countryName}
                                    tag={prediction.tags}
                                />
                                <PredictionTemplatePdfBody
                                    description={prediction.description}
                                    outcome={prediction.outcome}
                                    call_date={prediction.call_date}
                                    realization_date={prediction.realization_date}
                                    confidence={prediction.confidence}
                                    window={prediction.window}
                                    consensus={prediction.consensus || '-'}
                                />
                            </TBody>
                        </table>
                    </TD>
                </TR>
            </TBody>
        </table>
    );
};

export default PredictionTemplatePdf;
